const LAST_QUERY_KEY = 'last-playbook-query'

/**
 * Utility functions for managing last playbook query
 * This persists the user's query when playbook creation fails due to auth errors
 * and restores it when they return to try again
 */

export const getLastPlaybookQuery = (): string | null => {
  return localStorage.getItem(LAST_QUERY_KEY)
}

export const setLastPlaybookQuery = (query: string) => {
  localStorage.setItem(LAST_QUERY_KEY, query.trim())
}

export const clearLastPlaybookQuery = () => {
  localStorage.removeItem(LAST_QUERY_KEY)
}

export const getCurrentLastPlaybookQuery = (): string => {
  const query = getLastPlaybookQuery()
  return query || ''
}
